export const TEAM_OPENED = 'team-opened';
export const TEAM_MEMBER_SEARCHED = 'team-member-searched';
export const TEAM_MEMBER_OPENED = 'team-member-opened';
export const TEAM_MEMBER_INVITED = 'team-member-invited';
export const TEAM_MEMBER_DELETED = 'team-member-deleted';
